import { render, staticRenderFns } from "./luckdraw.vue?vue&type=template&id=fa867ee2&"
import script from "./luckdraw.vue?vue&type=script&lang=js&"
export * from "./luckdraw.vue?vue&type=script&lang=js&"
import style0 from "./luckdraw.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports